<template>
  <div data-app>
    <v-dialog persistent v-model="dialog" width="500">
      <template v-slot:[`activator`]="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" width="150px" height="150px" @click="imgClk(pathAddress)">
          <img :src="pathAddress" height="150px" width="150px" class="imgFilter" />
        </v-btn>
      </template>

      <!-- row -->
      <v-card>
      <v-card>
        <v-row class="mb-7">

          <v-btn color="indigo" absolute small left top    @click="imgDownload()">
              
              download
              <v-icon >
                mdi-download
              </v-icon>
            
          </v-btn>

          <v-btn color="indigo" absolute small top right   @click="closeBtn()">
            <v-icon  >
              mdi-close
            </v-icon>
          </v-btn>
        </v-row>
        
        
          <v-row>
            <v-card-title class="text-lg-h6 font-weight-medium">
              {{imgName}}
            </v-card-title>
          </v-row>

       
      </v-card>

      <img ref="imgDefect" id="defects" :src="pathAddress" height="100%" width="100%" class="imgFilter" />
      <v-card >
        <v-card-text class="font-weight-medium text-md-body-1" >

          Brightness
          <v-slider  max="200" track-color="grey" color="indigo" v-model="bVal" thumb-label ticks />
          Contrast
          <v-slider max="5" track-color="grey" color="indigo" v-model="cVal"  thumb-label ticks />

        </v-card-text>
      </v-card>
    </v-card>
    </v-dialog>
  </div>
</template>

<style>
.a-href {
  color: #ffffff;
  text-decoration: none;
}
.imgFilter {
  image-rendering: crisp-edges;
}
</style>

<script>
import globalConf from '../../../globalConf';

export default {
  props: ["pathAddress"],
  data() {
    return {
      dialog: false,
      bVal: 0,
      cVal: 0,
      imgDom: '',
      imgName: this.pathAddress.replace(globalConf.djangoBackend + '/media/images/', "").replace(".jpg",""),
    };
  },

  mounted() {
    // brighntess and contrast slider
    this.$watch(wVar => [wVar.bVal, wVar.cVal], () => {
      this.imgDom = this.$refs.imgDefect;
      this.imgDom.style.filter = 'brightness(' + ( 200 + this.bVal ) + '%) saturate(' + ( 1 + this.cVal ) + ')';
      if (this.bVal < 15) {
        this.imgDom.style.filter = 'brightness(' + ( 150 + this.bVal ) + '%) saturate(' + ( 1 + this.cVal ) + ')';
      }
    },
    {
      deep: true,
      flush: 'post'
    })
  },

  methods: {

    bIp() {
      this.sliderColor = 'indigo';
    },

    closeBtn() {
      this.dialog = false;
      this.bVal = 0;
      this.cVal = 0;
    },

    imgDownload() {
      let img = new Image();
      img.onload = () => {

        let canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        //redraw the canvas when values gets updated
        if ( this.bVal || this.cVal ) {
          ctx.filter = `brightness(${200 + this.bVal}%) saturate(${1 + this.cVal})`;
          ctx.drawImage(img, 0, 0);
        }

        var base64Image = this.getBase64Image(canvas);
        this.downloadURI(base64Image, this.imgName);
      };

      img.setAttribute('crossOrigin', 'anonymous');
      img.src = this.pathAddress;
    },

    getBase64Image(canvas) {
      let dataURL = canvas.toDataURL("image/jpeg");
      return dataURL;
    },

    downloadURI(uri, name) {
      // IE10+ : (has Blob, but not a[download] or URL)
      if (navigator.msSaveBlob) {
        const blob = this.dataURItoBlob(uri);
        return navigator.msSaveBlob(blob, name);
      }
      const link = document.createElement('a');
      link.download = name;
      link.href = uri;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    dataURItoBlob(dataurl) {
      const parts = dataurl.split(','), mime = parts[0].match(/:(.*?);/)[1];
      if ( parts[0].indexOf('base64') !== -1 ) {
        const bstr = atob(parts[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new Blob([u8arr], {type:mime})
      } else {
        const raw = decodeURIComponent(parts[1])
        return new Blob([raw], {type: mime})
      }
    },

    imgClk(p) {
      console.log("Img Name");
      console.log(p);
    },

    clog() {
      console.log(bVal);
    },

    zoomin() {
      let myImg = document.getElementById("defects");
      let currWidth = myImg.clientWidth;
      console.log();
      if (currWidth == 2500) return false;
      else {
        myImg.style.width = currWidth + 100 + "px";
      }
    },

    zoomout() {
      let myImg = document.getElementById("defects");
      let currWidth = myImg.clientWidth;
      if (currWidth == 100) return false;
      else {
        myImg.style.width = currWidth - 100 + "px";
      }
    }
  }
};
</script>